export default {
    Metadata: {
        Name: "GetDayOfYear",
        Description: "Returns the day of the year from a given date.",
        Syntax: "GetDayOfYear(date)",
        Keywords: ['Date'],
        Author: "DataVoke, Inc.",
    },
    execute(fromDate) {
        fromDate = app.dv.helpers.exprEng.expr.todate(fromDate);
        var dayOfYear = null;
        if (fromDate != null) {
            var dayCount = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334],
                mn = fromDate.getMonth(),
                dn = fromDate.getDate();

            dayOfYear = dayCount[mn] + dn;

            // If this is leap year, then rev the day (if appropriate)...AL
            if (mn > 1 && fromDate.isLeapYear())
                dayOfYear++;
        }

        return dayOfYear;

    },
};

